import {
	AchFeeTemplateFields,
	AriseFeesTemplateFields,
	FeeTemplateQueue,
	AchFeeTemplateQueue,
	AriseFeeTemplateQueue,
} from "globalConstants";
import { FeeTemplateQueueType, FeeTemplatesStatusTypes } from "types";
import { float6Normalizer } from "validators";

const { IsActive, IsDefault, TemplateId, Name } = FeeTemplateQueue;

export const mapFeeTemplateQueueDataFromServer = (
	data,
): FeeTemplateQueueType => {
	return {
		[IsDefault.name]: data?.[IsDefault.beName],
		[IsActive.name]: data?.[IsActive.beName],
		[TemplateId.name]: data?.[TemplateId.beName],
		[Name.name]: data?.[Name.beName],
	};
};

export const mapAchFeeTemplateQueueDataFromServer = (data: {
	[key: string]: any;
}) => {
	return {
		[AchFeeTemplateQueue.IsDefault.name]:
			data?.[AchFeeTemplateQueue.IsDefault.beName],
		[AchFeeTemplateQueue.IsActive.name]:
			data?.[AchFeeTemplateQueue.IsActive.beName],
		[AchFeeTemplateQueue.TemplateId.name]:
			data?.[AchFeeTemplateQueue.TemplateId.beName],
		[AchFeeTemplateQueue.Name.name]:
			data?.[AchFeeTemplateQueue.Name.beName],
	};
};

export const mapAchFeeTemplateDataToServer = (data: { [key: string]: any }) => {
	return {
		...data,
		[AchFeeTemplateFields.Status.name]:
			!!data?.[AchFeeTemplateFields.Status.name].value,
	};
};

export const mapAchFeeTemplateDataFromServer = (data: {
	[key: string]: any;
}) => {
	return {
		[AchFeeTemplateFields.IsDefault.name]:
			data?.[AchFeeTemplateFields.IsDefault.name],
		[AchFeeTemplateFields.Status.name]: FeeTemplatesStatusTypes.getByName(
			data?.[AchFeeTemplateFields.Status.name]?.toString(),
		),
		[AchFeeTemplateFields.TemplateName.name]:
			data?.[AchFeeTemplateFields.TemplateName.name],
		[AchFeeTemplateFields.SetupFee.name]: float6Normalizer(
			data?.[AchFeeTemplateFields.SetupFee.name],
		),
		[AchFeeTemplateFields.MonthlyFee.name]: float6Normalizer(
			data?.[AchFeeTemplateFields.MonthlyFee.name],
		),
		[AchFeeTemplateFields.TransactionFee.name]: float6Normalizer(
			data?.[AchFeeTemplateFields.TransactionFee.name],
		),
		[AchFeeTemplateFields.OriginationDiscountFee.name]: float6Normalizer(
			data?.[AchFeeTemplateFields.OriginationDiscountFee.name],
		),
		[AchFeeTemplateFields.OriginationLargeTransactionDiscountFee.name]:
			float6Normalizer(
				data?.[
					AchFeeTemplateFields.OriginationLargeTransactionDiscountFee
						.name
				],
			),
		[AchFeeTemplateFields.StandardReturnFee.name]: float6Normalizer(
			data?.[AchFeeTemplateFields.StandardReturnFee.name],
		),
		[AchFeeTemplateFields.NoticeOfChangeReturnFee.name]: float6Normalizer(
			data?.[AchFeeTemplateFields.NoticeOfChangeReturnFee.name],
		),
		[AchFeeTemplateFields.ChargebackReturnFee.name]: float6Normalizer(
			data?.[AchFeeTemplateFields.ChargebackReturnFee.name],
		),
		[AchFeeTemplateFields.AccountVerificationFee.name]: float6Normalizer(
			data?.[AchFeeTemplateFields.AccountVerificationFee.name],
		),
		[AchFeeTemplateFields.AccountVerificationPlusFee.name]:
			float6Normalizer(
				data?.[AchFeeTemplateFields.AccountVerificationPlusFee.name],
			),
	};
};

export const mapAriseFeeTemplateQueueDataFromServer = (data: {
	[key: string]: any;
}) => {
	return {
		[AriseFeeTemplateQueue.IsDefault.name]:
			data?.[AriseFeeTemplateQueue.IsDefault.beName],
		[AriseFeeTemplateQueue.IsActive.name]:
			data?.[AriseFeeTemplateQueue.IsActive.beName],
		[AriseFeeTemplateQueue.TemplateId.name]:
			data?.[AriseFeeTemplateQueue.TemplateId.beName],
		[AriseFeeTemplateQueue.Name.name]:
			data?.[AriseFeeTemplateQueue.Name.beName],
	};
};

export const mapAriseFeeTemplateDataToServer = (data: {
	[key: string]: any;
}) => {
	return {
		...data,
		[AriseFeesTemplateFields.Status.name]:
			!!data?.[AriseFeesTemplateFields.Status.name].value,
	};
};

export const mapAriseFeeTemplateDataFromServer = (data: {
	[key: string]: any;
}) => {
	return {
		[AriseFeesTemplateFields.IsDefault.name]:
			data?.[AriseFeesTemplateFields.IsDefault.name],
		[AriseFeesTemplateFields.Status.name]:
			FeeTemplatesStatusTypes.getByName(
				data?.[AriseFeesTemplateFields.Status.name]?.toString(),
			),
		[AriseFeesTemplateFields.TemplateName.name]:
			data?.[AriseFeesTemplateFields.TemplateName.name],
		[AriseFeesTemplateFields.PlatformSetupFee.name]: float6Normalizer(
			data?.[AriseFeesTemplateFields.PlatformSetupFee.name],
		),
		[AriseFeesTemplateFields.PlatformMonthlyFee.name]: float6Normalizer(
			data?.[AriseFeesTemplateFields.PlatformMonthlyFee.name],
		),
		[AriseFeesTemplateFields.CustomerVaultMonthlyFee.name]:
			float6Normalizer(
				data?.[AriseFeesTemplateFields.CustomerVaultMonthlyFee.name],
			),
		[AriseFeesTemplateFields.EnhancedDataTransactionFee.name]:
			float6Normalizer(
				data?.[AriseFeesTemplateFields.EnhancedDataTransactionFee.name],
			),
		[AriseFeesTemplateFields.CardTransactionAuthorizationFee.name]:
			float6Normalizer(
				data?.[
					AriseFeesTemplateFields.CardTransactionAuthorizationFee.name
				],
			),
		[AriseFeesTemplateFields.ECommercePluginSetupFee.name]:
			float6Normalizer(
				data?.[AriseFeesTemplateFields.ECommercePluginSetupFee.name],
			),
		[AriseFeesTemplateFields.ECommercePluginMonthlyFee.name]:
			float6Normalizer(
				data?.[AriseFeesTemplateFields.ECommercePluginMonthlyFee.name],
			),
		[AriseFeesTemplateFields.EMVDeviceSetupFee.name]: float6Normalizer(
			data?.[AriseFeesTemplateFields.EMVDeviceSetupFee.name],
		),
		[AriseFeesTemplateFields.AdditionalEmvDeviceMonthlyFee.name]:
			float6Normalizer(
				data?.[
					AriseFeesTemplateFields.AdditionalEmvDeviceMonthlyFee.name
				],
			),
		[AriseFeesTemplateFields.EnhancedDataSetupFee.name]: float6Normalizer(
			data?.[AriseFeesTemplateFields.EnhancedDataSetupFee.name],
		),
		[AriseFeesTemplateFields.CustomerVaultSetupFee.name]: float6Normalizer(
			data?.[AriseFeesTemplateFields.CustomerVaultSetupFee.name],
		),
		[AriseFeesTemplateFields.CustomerVaultAutomaticUpdateFee.name]:
			float6Normalizer(
				data?.[
					AriseFeesTemplateFields.CustomerVaultAutomaticUpdateFee.name
				],
			),
		[AriseFeesTemplateFields.MobileInvoicingPaymentsSetupFee.name]:
			float6Normalizer(
				data?.[
					AriseFeesTemplateFields.MobileInvoicingPaymentsSetupFee.name
				],
			),
		[AriseFeesTemplateFields.MobileInvoicingPaymentsMonthlyFee.name]:
			float6Normalizer(
				data?.[
					AriseFeesTemplateFields.MobileInvoicingPaymentsMonthlyFee
						.name
				],
			),
		[AriseFeesTemplateFields.MobileInvoicingPaymentsMessageFee.name]:
			float6Normalizer(
				data?.[
					AriseFeesTemplateFields.MobileInvoicingPaymentsMessageFee
						.name
				],
			),
		[AriseFeesTemplateFields.CardNetworkTokenizationToggle.name]:
			data?.[AriseFeesTemplateFields.CardNetworkTokenizationToggle.name],
		[AriseFeesTemplateFields.CardNetworkTokenizationSetupFee.name]:
			float6Normalizer(
				data?.[
					AriseFeesTemplateFields.CardNetworkTokenizationSetupFee.name
				],
			),
		[AriseFeesTemplateFields.CardNetworkTokenizationMonthlyFee.name]:
			float6Normalizer(
				data?.[
					AriseFeesTemplateFields.CardNetworkTokenizationMonthlyFee
						.name
				],
			),
		[AriseFeesTemplateFields.CardNetworkTokenizationPerItemFee.name]:
			float6Normalizer(
				data?.[
					AriseFeesTemplateFields.CardNetworkTokenizationPerItemFee
						.name
				],
			),
	};
};
